const PODCAST_ID = '2607590';

export const isConfigured = Boolean(PODCAST_ID);

export async function fetchFeed(): Promise<string> {
  if (!isConfigured) {
    throw new Error('Buzzsprout podcast ID not configured');
  }
  const res = await fetch(`https://feeds.buzzsprout.com/${PODCAST_ID}.rss`);
  if (!res.ok) {
    throw new Error(`Feed fetch failed: ${res.status} ${res.statusText}`);
  }
  return res.text();
}
